export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="ila-rb" x1="6" y1="37" x2="42" y2="37" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#FF6B6B" />
        <stop offset="0.35" stopColor="#F9D876" />
        <stop offset="0.68" stopColor="#4ECDC4" />
        <stop offset="1" stopColor="#45B7D1" />
      </linearGradient>
    </defs>
    <path d="M7 37a17 17 0 0 1 34 0" stroke="url(#ila-rb)" strokeWidth="3.6" strokeLinecap="round" />
    <path d="M14 37a10 10 0 0 1 20 0" stroke="url(#ila-rb)" strokeWidth="3.6" strokeLinecap="round" opacity="0.62" />
    <path d="M20.5 37a3.5 3.5 0 0 1 7 0" stroke="url(#ila-rb)" strokeWidth="3.6" strokeLinecap="round" opacity="0.35" />
    <path d="M24 4l2 4.6 4.6 2-4.6 2-2 4.6-2-4.6-4.6-2 4.6-2z" fill="#9B5DE5" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-3">
    <LogoMark className="h-10 w-10 shrink-0" />
    <span className="leading-none">
      <span className={`block font-display text-[1.35rem] font-semibold tracking-tight ${light ? "text-[#FDFBF7]" : "text-[#1A1A1A]"}`}>
        Iris Languages
      </span>
      <span className={`mt-1 block text-[0.55rem] font-medium uppercase tracking-[0.42em] ${light ? "text-[#FDFBF7]/60" : "text-[#5C5C5C]"}`}>
        Academy
      </span>
    </span>
  </span>
);

export default Logo;
